module.exports = __webpack_public_path__ + "static/media/icon_voucher.bca70dd2.svg";